/**
 * Charts Index - Phase 5 Implementation
 * Main export file for all chart components
 * Provides unified interface for report chart selection
 */

import React from 'react';
import { ReportType } from '../../../types/reports';
import { SalesDashboardChart } from './SalesDashboardChart';
import { CashFlowChart } from './CashFlowChart';
import { ProfitLossChart } from './ProfitLossChart';
import { BalanceSheetChart } from './BalanceSheetChart';
import { InventoryChart } from './InventoryChart';
import { CustomerOutstandingChart } from './CustomerOutstandingChart';
import { VendorPaymentsChart } from './VendorPaymentsChart';

interface ReportChartProps {
  reportType: ReportType;
  data: any[];
  isLoading?: boolean;
  error?: string;
  className?: string;
}

const ReportChart: React.FC<ReportChartProps> = ({
  reportType,
  data,
  isLoading = false,
  error,
  className
}) => {
  const chartProps = {
    data,
    isLoading,
    error,
    className
  };

  switch (reportType) {
    case 'sales-dashboard':
      return <SalesDashboardChart {...chartProps} />;
    case 'cash-flow-statement':
      return <CashFlowChart {...chartProps} />;
    case 'profit-loss':
      return <ProfitLossChart {...chartProps} />;
    case 'balance-sheet':
      return <BalanceSheetChart {...chartProps} />;
    case 'inventory-status':
      return <InventoryChart {...chartProps} />;
    case 'customer-outstanding':
      return <CustomerOutstandingChart {...chartProps} />;
    case 'vendor-payments':
      return <VendorPaymentsChart {...chartProps} />;
    default:
      return (
        <div className="flex items-center justify-center h-64">
          <div className="text-center space-y-2">
            <p className="text-muted-foreground">Chart type not implemented</p>
            <p className="text-sm text-muted-foreground">
              Report type: {reportType}
            </p>
          </div>
        </div>
      );
  }
};

export { ReportChart };
export * from './SalesDashboardChart';
export * from './CashFlowChart';
export * from './ProfitLossChart';
export * from './BalanceSheetChart';
export * from './InventoryChart';
export * from './CustomerOutstandingChart';
export * from './VendorPaymentsChart';